import React from 'react'
import styled from 'styled-components'
import { textColor } from 'styles/colors'
import { fontSizes } from 'styles/typography'

const Consent = styled.p`
  color: ${textColor};
  text-align: justify;
  font-size: ${fontSizes.small};
`
const Consent1 = styled.div`
  color: ${textColor};
  text-align: justify;
  font-size: ${fontSizes.tiny};
`

const RegisterLabel = <Consent>By clicking “Register”, I agree to:</Consent>

const emailSubscription = (
  <Consent>
    Vuse sending me information on products, services and research opportunities relating to Vuse and other current and
    future brands distributed by Imperial Tobacco Company Ltd. that may be tailored to my preferences, purchases and app
    usage, including cart reminders. You can unsubscribe at any time. Tap the{' '}
    <a href={'https://www.vuse.com/ca/en/contact-us/'} target="_blank" rel="noreferrer">
      Contact Us
    </a>{' '}
    link for our contact information.
  </Consent>
)
const emailOptinConsent = (
  <Consent>
    Yes, I want Vuse to sending me information on products, services and research opportunities relating to Vuse and
    other current and future brands distributed by Imperial Tobacco Company Ltd. that may be tailored to my preferences,
    purchases and app usage, including cart reminders. You can unsubscribe at any time. Tap the{' '}
    <a href={'https://www.vuse.com/ca/en/contact-us/'} target="_blank" rel="noreferrer">
      Contact Us
    </a>{' '}
    link for our contact information.
  </Consent>
)

const vusePlusOptInConsent = (
  <Consent>
    Yes, I want to join the MYVUSE Rewards loyalty program! Membership can be cancelled at any time. By joining, you
    agree that you have read and accepted the{' '}
    <a href="https://www.vuse.com/ca/en/pages/myvuse-rewards-terms-and-conditions" target="_blank" rel="noreferrer">
      MYVUSE Rewards Terms and Conditions
    </a>
    .
  </Consent>
)

const privacyPolicy = (
  <Consent>
    Your personal information will be used to provide me with Vuse products and services, remember my preferences,
    tailor my experience on the Vuse website, and provide me with content about Vuse products and services that may be
    of interest to me. For more information on how my information may be processed, I can consult the{' '}
    <a href={'https://www.vuse.com/ca/en/pages/privacy-policy/'} target="_blank" rel="noreferrer">
      Privacy Policy
    </a>
    . By creating an account, I acknowledge and agree to the processing of my personal information for these purposes.
    By registering, I acknowledge that I have read, understood and agree to the{' '}
    <a href={'https://www.vuse.com/ca/en/pages/terms-conditions/'} target="_blank" rel="noreferrer">
      terms and conditions
    </a>
    .
  </Consent>
)
const patronScanPolicy = (
  <Consent1>
    <p>
      Vuse products and services are only intended for adults who have reached the legal age in their province of
      residence.
    </p>
    <p>
      You consent to the collection and use of your personal information (full name, date of birth, postal code,
      consumption of cigarettes or vape products, and account email address and password) by Imperial Tobacco Canada
      Limited and/or our service providers for the following purposes:
      <ul>
        <li>
          To confirm that you meet the legal age requirement to access Vuse products and services. To verify your age,
          we use a third-party service provider that scans your government-issued photo identification. Your personal
          information is not stored or used by the provider for any other purpose and is automatically deleted from the
          providers system once age verification is complete. If your initial identification is deemed invalid or
          unreadable, you may be asked to rescan a valid, government-issued photo ID;
        </li>
        <li>
          To facilitate account creation by automatically populating your verified ID information into the registration
          form;
        </li>
        <li>
          To add you to our marketing database and manage your interactions with us, including the delivery of offers
          and communications, in accordance with applicable laws.
        </li>
      </ul>
    </p>
    <p>
      For more information on how we process your personal information, including information about how you can access
      or correct your personal information, or how you can withdraw consent, see the{' '}
      <a href={'https://www.vuse.com/ca/en/pages/privacy-policy'} target="_blank" rel="noreferrer">
        Privacy Policy
      </a>
      .
    </p>
  </Consent1>
)

export { emailSubscription, vusePlusOptInConsent, privacyPolicy, RegisterLabel, patronScanPolicy, emailOptinConsent }
